module.exports = __webpack_public_path__ + "img/video-lesson-main.d443d12a.jpg";